import type { ButtonHTMLAttributes, FC } from "react";

import { I18n } from "@ui/components/I18n";
import classnames from "classnames";

import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";

import styles from "./MultipleFlavorSelectorToggler.module.scss";

type MultipleFlavorSelectorTogglerProps = {
  selectedItemsCount: number;
  itemsLimit: number;
  availableFlavorsCount: number;
  isSelectorOpen: boolean;
  controlledElementId: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const MultipleFlavorSelectorToggler: FC<MultipleFlavorSelectorTogglerProps> = ({
  selectedItemsCount,
  itemsLimit,
  availableFlavorsCount,
  isSelectorOpen,
  controlledElementId,
  ...restProps
}) => (
  <button
    type="button"
    className={styles.container}
    data-testid="multiple-flavor-selector-toggler"
    aria-expanded={isSelectorOpen}
    aria-controls={controlledElementId}
    aria-haspopup="dialog"
    {...restProps}
  >
    <span className={styles.headline} aria-live="polite">
      <I18n t="productdetails.sticks.selection">
        <strong>{selectedItemsCount}</strong>
        {itemsLimit}
      </I18n>
    </span>

    <div className={styles.ctaWithArrow}>
      <span className={styles.availableFlavors}>
        <I18n t="productdetails.sticks.amount">{availableFlavorsCount}</I18n>
      </span>

      <ChevronForwardIcon
        aria-hidden="true"
        className={classnames(styles.icon, {
          [styles.active]: isSelectorOpen,
        })}
      />
    </div>
  </button>
);
